import { CONNECTION_HOLDS_AFTER_MS } from '../realtime/startHubWithRetry';
import { ObservableStore } from './observableStore';

export type RealtimeConnectionState =
  | { status: 'connecting' }
  | { status: 'connected' }
  | { status: 'reconnecting'; disconnectedSince: Date; failedAttempts: number };

const CONNECTING: RealtimeConnectionState = { status: 'connecting' };

export class ConnectionStateTracker extends ObservableStore<RealtimeConnectionState> {
  private failedAttempts = 0;
  private disconnectedSince: Date | null = null;
  private holdTimer: ReturnType<typeof setTimeout> | undefined;

  public constructor() {
    super(CONNECTING);
  }

  public static get connectingSnapshot(): RealtimeConnectionState {
    return CONNECTING;
  }

  public markDisconnected(): void {
    this.clearHoldTimer();

    this.disconnectedSince ??= new Date();
    this.failedAttempts += 1;

    this.replace({
      status: 'reconnecting',
      disconnectedSince: this.disconnectedSince,
      failedAttempts: this.failedAttempts,
    });
  }

  public markConnected(): void {
    if (this.disconnectedSince === null) {
      this.markStable();
      return;
    }

    this.clearHoldTimer();
    this.holdTimer = setTimeout(() => this.markStable(), CONNECTION_HOLDS_AFTER_MS);
  }

  public markStable(): void {
    this.clearHoldTimer();

    this.failedAttempts = 0;
    this.disconnectedSince = null;
    this.replace({ status: 'connected' });
  }

  public dispose(): void {
    this.clearHoldTimer();
    this.clearListeners();
  }

  private clearHoldTimer(): void {
    clearTimeout(this.holdTimer);
    this.holdTimer = undefined;
  }
}
